module.exports = __webpack_public_path__ + "img/kitchen-debeavoir.fb0ee2f2.jpg";